import { useState, useEffect } from 'react';
import './NavbarComponent.css';
import { subscribeScroll } from '../responsive/scroll';

const NavbarComponent = () => {
    const [ hideNav, setHideNav ] = useState(false);

    // Hide while scrolling down, show while scrolling up.
    // (Previously a new scroll listener was added on every render and never removed.)
    useEffect(() => {
      let prevY = window.scrollY;
      return subscribeScroll((y) => {
        if (y > prevY) setHideNav(true);
        else if (y < prevY) setHideNav(false);
        prevY = y;
      });
    }, []);

    return <div className={`nav nav-bg grid-nav-parent ${hideNav ? 'hide-nav' : ''}`}>
        <div className="grid-nav-child grid-1 inter-text yellow nav-logo"><a href="#pixay">PIXAY</a></div>
        <div className="grid-nav-child grid-2 inter-text white nav-link"><a href="#meet-orbiin">Orbiin</a></div>
        <div className="grid-nav-child grid-3 inter-text white nav-link"><a href="#r2">R²</a></div>
        <div className="grid-nav-child grid-4 inter-text white nav-link"><a href="#dispatcher">Dispatcher</a></div>
        <div className="grid-nav-child grid-5 inter-text white nav-link"><a href="#demo">Demo</a></div>
    </div>
};

export default NavbarComponent;
